import { useEffect, useState } from 'react';
import qs from 'qs';

const useQueryParams = <T extends { [key: string]: string }>(): {
  queryString: string;
  queryParams: T;
} => {
  const parseState = (query) => ({
    queryString: query,
    queryParams: query
      ? (qs.parse(globalThis?.location?.search, {
          ignoreQueryPrefix: true,
        }) as T)
      : null,
  });
  const [state, setState] = useState(parseState(globalThis?.location?.search));
  useEffect(() => {
    setState(parseState(globalThis?.location?.search));
  }, [globalThis?.location?.search]);
  return state;
};

export default useQueryParams;
